import "./index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { Routes } from "./utils/routes/react-router-lazy.tsx";

if (!import.meta.env.VITE_API_URL) {
  console.warn(
    "VITE_API_URL is not set, defaulting to http://localhost:5004/api"
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Routes />
  </StrictMode>
);
